import { Link } from 'react-router-dom'
import './footer.css'

const Footer = () => {
    return (
        <footer className="main-footer">
            <div className="main-footer__inner">
                <img
                    className="footer-logo"
                    src="/dd-logo-white-transparent.png"
                    alt="DimeDock DD Logo"
                />
                
                <Link className="support-link" to="/support">
                    Contact Support
                </Link>

                <p className="copyright-text">&copy; 2024 &ndash; DimeDock</p>
            </div>
        </footer>
    )
}

export default Footer